const injected = new Set();

export function getActiveScript() {
  if (document.currentScript) {
    return document.currentScript;
  }
  const scripts = document.getElementsByTagName('script');
  return scripts[scripts.length - 1] || null;
}

export function ensureTrailingSlash(value) {
  if (!value) {
    return '';
  }
  return value.endsWith('/') ? value : `${value}/`;
}

export function mergeConfig(...sources) {
  return sources.reduce((acc, source) => {
    if (!source || typeof source !== 'object') {
      return acc;
    }
    Object.entries(source).forEach(([key, val]) => {
      if (val === undefined) {
        return;
      }
      acc[key] = val;
    });
    return acc;
  }, {});
}

export function createElement(tag, options = {}) {
  const element = document.createElement(tag);
  if (options.className) {
    element.className = options.className;
  }
  if (options.text) {
    element.textContent = options.text;
  }
  if (options.attrs) {
    Object.entries(options.attrs).forEach(([key, val]) => {
      if (val !== undefined && val !== null) {
        element.setAttribute(key, val);
      }
    });
  }
  return element;
}

export function applyStyles(node, styles = {}) {
  Object.entries(styles).forEach(([prop, val]) => {
    if (val !== undefined) {
      node.style[prop] = val;
    }
  });
}

export function injectStyles(id, cssText) {
  if (injected.has(id)) {
    return;
  }
  const style = document.createElement('style');
  style.id = id;
  style.textContent = cssText;
  document.head.appendChild(style);
  injected.add(id);
}
